import React from 'react'
import PropTypes from 'prop-types'

export const ProgressContext = React.createContext({})

const ProgressProvider = React.memo(({ children }) => {
  const [showProgress, setShowProgress] = React.useState(false)

  return (
    <ProgressContext.Provider value={{ showProgress, setShowProgress }}>
      {children}
    </ProgressContext.Provider>
  )
})

ProgressProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ProgressProvider
